{
  "labels": {
    "textSingleLine": "Văn bản - Một dòng",
    "textMultipleLines": "Văn bản - Nhiều dòng",
    "date": "Ngày",
    "trueFalse": "Đúng/Sai",
    "singleDocument": "Một tài liệu",
    "multiDocument": "Nhiều tài liệu",
    "number": "Số",
    "eMail": "Email",
    "phone": "Điện thoại",
    "dropDownSingleSelectList": "Danh sách thả xuống chọn một",
    "dropDownMultiSelectList": "Danh sách thả xuống chọn nhiều",
    "comboBox": "Hộp kết hợp",
    "timestamp": "Dấu thời gian",
    "featureLink": "Liên kết tính năng"
  },
  "descriptions": {
    "openTextFieldSingleLine": "Trường văn bản tự do, một dòng",
    "openTextFieldMultipleLines": "Trường văn bản tự do, nhiều dòng",
    "formatMmDdYyyy": "Định dạng MM/DD/YYYY",
    "toggleButton": "Nút bật/tắt",
    "singleFileUploadField": "Trường tải lên một tệp",
    "multipleFileUploadField": "Trường tải lên nhiều tệp",
    "numericInputField": " Trường nhập số",
    "emailAddressInputField": "Trường nhập địa chỉ email",
    "format1XxxXxxXxxx": "Định dạng +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "Chọn một tùy chọn từ danh sách",
    "selectMultipleOptionsFromAList": "Chọn nhiều tùy chọn từ danh sách",
    "singleOptionDropDownListOpenTextField": "Danh sách thả xuống chọn một + trường văn bản tự do",
    "dateAndTimeFields": "Trường ngày và giờ",
    "linkToTheFormFeatures": "Liên kết đến các tính năng biểu mẫu"
  }
}
